import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL;
const TOKEN_KEY = 'shivam_clinic_token';

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const client = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res.data,
  (error) => {
    // A dead session should drop the user back to the login screen rather than
    // leaving half-loaded pages behind.
    if (error.response?.status === 401 && tokenStore.get()) {
      tokenStore.clear();
      if (!window.location.pathname.startsWith('/login')) window.location.href = '/login';
    }

    const message =
      error.response?.data?.message ||
      (error.code === 'ERR_NETWORK'
        ? 'Cannot reach the server. Is the backend running?'
        : error.message);

    return Promise.reject(Object.assign(new Error(message), {
      status: error.response?.status,
      details: error.response?.data?.details,
    }));
  },
);

export default client;
